var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ui-section-header',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.$t('Components.Reservation.MailLog.Main_Title')))]},proxy:true}])}),_c('MailLog',{attrs:{"mailLogs":_vm.mailLogs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }